module.exports = __webpack_public_path__ + "media/assets/images/flags/ly-052496d351fbad7c18ec1992d57cf7e4.svg";